// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"19a32954","507":"048338cc","983":"c2050153"}[chunkId] + ".chunk.js";
};